import { useDeleteFormAttachmentsMutation } from './formUpload.api'

const useDeleteAttachment = () => {
  const [deleteAttachment, deleteMutationStatus] =
    useDeleteFormAttachmentsMutation()

  return { deleteMutationStatus, deleteAttachment }
}

export default useDeleteAttachment
